__turbopack_context__.v({
  "blog_title_nav": "Blog-module__bTdBVW__blog_title_nav",
});
